module.exports = __webpack_public_path__ + "img/small-15.52fdb003.webp";